module.exports = __webpack_public_path__ + "img/off.59566d2b.svg";